import LoginController from './controllers/loginController';
import LoginFactory from './services/loginFactory';

import templateLogin from './templates/login.tmpl.html';

const MODULE_NAME = 'App.Login';
const module = angular
    .module(MODULE_NAME, [])
    .controller('LoginController', LoginController)
    .factory('loginFactory', LoginFactory)
    .config(function($stateProvider) {
        'ngInject';

        $stateProvider // eslint-disable-line
            .state('login', {
                url: '/login?user&token&countryCode&ReturnUrl',
                resolve: {
                    umbracoCredentials: ['$stateParams', function($stateParams) {
                        const {user, token, countryCode} = $stateParams;
                        return (user && token)
                            ? {
                            user,
                            password: token,
                            countryCode,
                        }
                            : false;
                    }],
                    adminLink: ['$stateParams', function($stateParams) {
                        return !!$stateParams.ReturnUrl;
                    }],
                },
                views: {
                    '': {
                        template: templateLogin,
                        controller: LoginController,
                        controllerAs: 'loginCtrl',
                    },
                },
            })

            .state('autologin', {
                url: '/autologin?accessToken&refreshToken',
                controller: ['$stateParams', 'loginFactory', function($stateParams, loginFactory) {
                    loginFactory.autoLogin($stateParams.accessToken, $stateParams.refreshToken);
                }],
            });
    });

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/login/login-module.js